export function getDataOwner (state) {
    return state.dataOwner
}